import React from 'react'
import { Button } from 'react-bootstrap'

export const ButtonCustom = ({variant,text,onClick, disabled = false, isLoading = false, style={},  type= 'button', icon=null}) => {
  return (
      <Button style={style} variant={variant} onClick={onClick} disabled={disabled || isLoading} type={type} >
        {isLoading && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>}
        {' ' + text} {icon}
      </Button>
  )
}


{/* <Button variant="primary">Primary</Button>{' '}
      <Button variant="secondary">Secondary</Button>{' '}
      <Button variant="success">Success</Button>{' '}
      <Button variant="warning">Warning</Button>{' '}
      <Button variant="danger">Danger</Button>{' '}
      <Button variant="info">Info</Button>{' '}
      <Button variant="light">Light</Button>{' '}
      <Button variant="dark">Dark</Button>
      <Button variant="link">Link</Button> */}